import {
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS_SUCCESS,
  FETCH_ANNOUNCEMENTS_FAILURE,
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_SUCCESS,
  CREATE_ANNOUNCEMENT_FAILURE,
  RESET_ANNOUNCEMENT_STATE,
} from './announcementTypes';

export const fetchAnnouncementsRequest = (params) => ({
  type: FETCH_ANNOUNCEMENTS_REQUEST,
  payload: params,
});

export const fetchAnnouncementsSuccess = (data) => ({
  type: FETCH_ANNOUNCEMENTS_SUCCESS,
  payload: data,
});

export const fetchAnnouncementsFailure = (error) => ({
  type: FETCH_ANNOUNCEMENTS_FAILURE,
  payload: error,
});

export const createAnnouncementRequest = (data) => ({
  type: CREATE_ANNOUNCEMENT_REQUEST,
  payload: data,
});

export const createAnnouncementSuccess = (message) => ({
  type: CREATE_ANNOUNCEMENT_SUCCESS,
  payload: message,
});

export const createAnnouncementFailure = (error) => ({
  type: CREATE_ANNOUNCEMENT_FAILURE,
  payload: error,
});

export const resetAnnouncementState = () => ({
  type: RESET_ANNOUNCEMENT_STATE,
});
